import { NgModule } from '@angular/core';
import { ListAdvisoryCommunityComponent } from './list-advisory-community/list-advisory-community.component';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: ListAdvisoryCommunityComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TgadvisoryCommunityRoutingModule { }
